import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

export const tabEnum = {
  STUDENT_INFO: 0,
  STUDENT_CONTACT_INFO: 1,
  CHARGE_PERMISSION: 2,
};

export const notWithdrawableStatuses = [
  StatusEnum.Deleted,
  StatusEnum.Withdrawn,
  StatusEnum.Catering,
];

export const ChargeDescriptions = {
  Y:
    'Anything the customer purchases can be charged to their account, even when it will result in a negative balance.',
  N:
    'The customer cannot charge anything that will result in a negative balance on their account.',
  M:
    'The customer can only charge meals when it will result in a negative balance on their account.',
  K:
    'The customer can only charge milk when it will result in a negative balance on their account.',
  B:
    'The customer can only charge meals or milk when it will result in a negative balance on their account.',
};

export const freeOption = [{ key: '2', value: '2', text: '2' }];



// WEBPACK FOOTER //
// ./src/pages/accountsetup/helpers/AccountSetupConstants.js